const form = {
  formId: "new-user-form",
  formField: {
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId1: {
      name: "taxId",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    address: {
      name: "address",
      label: "[06] Địa chỉ:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    district: {
      name: "district",
      label: "[07] Quận/huyện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    province: {
      name: "province",
      label: "[08] Tỉnh/thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    phone: {
      name: "phone",
      label: "[09] Điện thoại:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax: {
      name: "fax",
      label: "[10] Fax:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email: {
      name: "email",
      label: "[11] Email:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    organizationPayingName: {
      name: "organizationPayingName",
      label: "[12] Tên tổ chức trả thu nhập:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    taxId2: {
      name: "taxId2",
      label: "[13] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    district2: {
      name: "district2",
      label: "[16] Quận/huyện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    province2: {
      name: "province2",
      label: "[15] Tỉnh/thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    address2: {
      name: "address2",
      label: "[14] Địa chỉ:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[17] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[18] Mã số thuế đại lý:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    agencyContract: {
      name: "agencyContract",
      label: "[19] Hợp đồng đại lý thuế:Số:",
      type: "text",
      placeholder: "",
    },
    agencyContractDate: {
      name: "agencyContractDate",
      label: "Ngày",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },
    // foot
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
